import { Injectable } from '@angular/core';
import { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import { ContractHistoryPageInterface } from '@zaoblako/shared/modules/document/dtos/contract-history/contract-history-page.dto';
import { ContractFindInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-find.dto';
import { ContractPageInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-page.dto';
import { ContractQueryInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-query.dto';
import { ContractSwitchStatusInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-switch-status.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContractService extends BaseService {
  protected baseUrl = '/finance/document/contract';

  public findWithPagination(queryParams?: ContractQueryInterface): Observable<ContractPageInterface> {
    return this.http.get<ContractPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public switchStatus(id: number, body: ContractSwitchStatusInterface): Observable<ContractFindInterface> {
    return this.http.post<ContractFindInterface>(`${this.baseUrl}/${id}/switch-status`, body);
  }

  public getHistoryById(id: number, params: PaginationQueryInterface): Observable<ContractHistoryPageInterface> {
    return this.http.get<ContractHistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(params)
    });
  }

  public restore(id: number): Observable<ContractFindInterface> {
    return this.http.post<ContractFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public refreshDetails(params?: ContractQueryInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/refresh-1c`, {}, { params: this.objectToHttpParams(params) });
  }
}
